import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import toast from 'react-hot-toast';

const TransactionDetails = ({ paymentOrder }) => {
  const [showFullIds, setShowFullIds] = useState(false);

  const copyToClipboard = (text, label) => {
    navigator?.clipboard?.writeText(text);
    toast?.success(`${label} copied to clipboard`);
  };

  const maskId = (id) => {
    if (!id) return 'N/A';
    if (showFullIds) return id;
    return `${id?.slice(0, 8)}...${id?.slice(-4)}`;
  };

  const rows = [
    {
      label: 'Razorpay Payment ID',
      value: maskId(paymentOrder?.razorpay_payment_id),
      copyValue: paymentOrder?.razorpay_payment_id,
      copyLabel: 'Payment ID',
    },
    {
      label: 'Razorpay Order ID',
      value: maskId(paymentOrder?.razorpay_order_id),
      copyValue: paymentOrder?.razorpay_order_id,
      copyLabel: 'Order ID',
    },
  ];

  return (
    <div style={{
      background: 'var(--card, #ffffff)',
      border: '1px solid var(--border, #e2e8f0)',
      borderRadius: 16, padding: '28px 28px 32px',
      fontFamily: 'inherit',
    }}>

      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 24 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <Icon name="CreditCard" size={22} color="#004AAD" />
          <h2 style={{
            fontFamily: "'Sansation', sans-serif",
            fontSize: 20, fontWeight: 700,
            color: 'var(--foreground, #0f172a)', margin: 0,
          }}>Transaction Details</h2>
        </div>
        <button
          onClick={() => setShowFullIds(!showFullIds)}
          style={{
            display: 'inline-flex', alignItems: 'center', gap: 5,
            background: 'none', border: 'none', cursor: 'pointer',
            fontSize: 12, fontWeight: 600, color: '#004AAD',
            fontFamily: 'inherit', padding: '4px 8px', borderRadius: 6,
            transition: 'opacity 0.15s',
          }}
          onMouseEnter={e => e.currentTarget.style.opacity = '0.75'}
          onMouseLeave={e => e.currentTarget.style.opacity = '1'}
        >
          <Icon name={showFullIds ? 'EyeOff' : 'Eye'} size={13} color="#004AAD" />
          {showFullIds ? 'Hide' : 'Show'} Full IDs
        </button>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>

        {/* ID rows — copyable */}
        {rows.map(({ label, value, copyValue, copyLabel }) => (
          <div key={label} style={{
            display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12,
            padding: '14px 16px',
            background: 'var(--muted, #f8fafc)',
            border: '1px solid var(--border, #e2e8f0)',
            borderRadius: 10,
          }}>
            <div style={{ flex: 1, minWidth: 0 }}>
              <p style={{ fontFamily: 'inherit', fontSize: 11, color: 'var(--muted-foreground, #64748b)', margin: '0 0 3px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.06em' }}>
                {label}
              </p>
              <p style={{ fontFamily: 'monospace', fontSize: 13, fontWeight: 600, color: 'var(--foreground, #0f172a)', margin: 0, wordBreak: 'break-all' }}>
                {value}
              </p>
            </div>
            <button
              onClick={() => copyToClipboard(copyValue, copyLabel)}
              title={`Copy ${copyLabel}`}
              style={{
                flexShrink: 0, padding: '7px', borderRadius: 8,
                border: '1px solid var(--border, #e2e8f0)',
                background: 'var(--card, #fff)', cursor: 'pointer',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                transition: 'border-color 0.15s, color 0.15s',
                color: 'var(--muted-foreground, #94a3b8)',
              }}
              onMouseEnter={e => { e.currentTarget.style.borderColor = '#004AAD'; e.currentTarget.style.color = '#004AAD'; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = 'var(--border, #e2e8f0)'; e.currentTarget.style.color = 'var(--muted-foreground, #94a3b8)'; }}
            >
              <Icon name="Copy" size={14} />
            </button>
          </div>
        ))}

        {/* Payment Method */}
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: '14px 16px',
          background: 'var(--muted, #f8fafc)',
          border: '1px solid var(--border, #e2e8f0)',
          borderRadius: 10,
        }}>
          <div>
            <p style={{ fontFamily: 'inherit', fontSize: 11, color: 'var(--muted-foreground, #64748b)', margin: '0 0 3px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.06em' }}>
              Payment Method
            </p>
            <p style={{ fontFamily: 'inherit', fontSize: 13, fontWeight: 600, color: 'var(--foreground, #0f172a)', margin: 0 }}>
              {paymentOrder?.payment_method || 'Razorpay'}
            </p>
          </div>
          <Icon name="CreditCard" size={18} color="var(--muted-foreground, #94a3b8)" />
        </div>

        {/* Currency */}
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: '14px 16px',
          background: 'var(--muted, #f8fafc)',
          border: '1px solid var(--border, #e2e8f0)',
          borderRadius: 10,
        }}>
          <div>
            <p style={{ fontFamily: 'inherit', fontSize: 11, color: 'var(--muted-foreground, #64748b)', margin: '0 0 3px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.06em' }}>
              Currency
            </p>
            <p style={{ fontFamily: 'inherit', fontSize: 13, fontWeight: 600, color: 'var(--foreground, #0f172a)', margin: 0 }}>
              {paymentOrder?.currency === 'INR' ? 'Indian Rupee (INR)' : 'US Dollar (USD)'}
            </p>
          </div>
          <span style={{
            fontFamily: "'Sansation', sans-serif",
            fontSize: 20, fontWeight: 700, color: 'var(--foreground, #0f172a)',
          }}>
            {paymentOrder?.currency === 'INR' ? '₹' : '$'}
          </span>
        </div>

        {/* Transaction Status */}
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: '14px 16px',
          background: 'rgba(22,163,74,0.05)',
          border: '1px solid rgba(22,163,74,0.20)',
          borderRadius: 10,
        }}>
          <div>
            <p style={{ fontFamily: 'inherit', fontSize: 11, color: 'var(--muted-foreground, #64748b)', margin: '0 0 3px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.06em' }}>
              Transaction Status
            </p>
            <p style={{ fontFamily: 'inherit', fontSize: 13, fontWeight: 700, color: '#16a34a', margin: 0 }}>
              Payment Captured
            </p>
          </div>
          <div style={{
            width: 34, height: 34, borderRadius: '50%',
            background: 'rgba(22,163,74,0.10)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            <Icon name="CheckCircle2" size={18} color="#16a34a" />
          </div>
        </div>
      </div>

      {/* Security note */}
      <div style={{
        marginTop: 20, padding: '14px 16px',
        background: 'rgba(0,74,173,0.04)',
        border: '1px solid rgba(0,74,173,0.15)',
        borderRadius: 10,
        display: 'flex', alignItems: 'flex-start', gap: 10,
      }}>
        <Icon name="Lock" size={15} color="#004AAD" style={{ flexShrink: 0, marginTop: 1 }} />
        <div>
          <p style={{ fontFamily: 'inherit', fontSize: 12, fontWeight: 600, color: 'var(--foreground, #0f172a)', margin: '0 0 2px' }}>
            Secure Transaction
          </p>
          <p style={{ fontFamily: 'inherit', fontSize: 12, color: 'var(--muted-foreground, #64748b)', margin: 0, lineHeight: 1.6 }}>
            This transaction was processed securely through Razorpay. Keep these reference numbers for your records.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TransactionDetails;